import { useHistory } from 'react-router-dom';
import { ReactComponent as WarningSVG } from '../../icons/warning.svg';
import { userShape } from 'helpers/shared_types';

const IntellioWarning = ({ user }) => {
  const history = useHistory();

  if (user.role !== 'doctor' || user.intellioId) {
    return null;
  }

  return (
    <div className="treatment-info-wrapper w-100 mih25 flex flex-row pa4">
      <div className="flex-auto flex-grow-0 pa2">
        <WarningSVG className="svg-warning" />
      </div>
      <div className="flex-auto flex flex-column justify-between pa1">
        <div className="fw5 red-d3">
          Your Intellio Next account is not set up!
        </div>
        <div className="red-d1 fw3">
          To send invoices to Social Security, you should create an Intellio
          Next account.
        </div>
      </div>
      <div
        className="flex-auto self-center flex-grow-0 fw5 red-d3 pointer dim-lite"
        onClick={() => history.push('/intellio_account_create')}
      >
        Set up Intellio Next →
      </div>
    </div>
  );
};

IntellioWarning.propTypes = {
  user: userShape.isRequired,
};

export default IntellioWarning;
